export const  RouteType = [
  {
    id:0,
    name:"Waypoint route" ,
    key:'waypoint', // => utiliser dans kml Folder.templateType
    img:  
    ' ',  
  }, 
];



export const  CamSettings = {
  'M30':[    
    {
      id:0,
      name:"WIDE" ,
      key:'wide',
    },
    {
      id:1,
      name:"ZOOM" ,
      key:'zoom',
    },
  ],
  'M30T':[
    {
      id:0,
      name:"WIDE" ,
      key:'wide',
    },
    {
      id:1,
      name:"ZOOM" ,
      key:'zoom',
    },
    {
      id:2,
      name:"IR" ,
      key:'ir',
    },
  ],
  'Mavic':[],
  'M3D':[
    {
      id:0,
      name:"VISIBLE" ,
      key:'visable',
    },
  ],
  'M3TD':[  
    {
      id:0,
      name:"VISIBLE" ,
      key:'visable',
    },
    {
      id:1,
      name:"IR" ,
      key:'ir',
    },
  ],
  'M4':[
    {
      id:0,
      name:"VISIBLE" ,
      key:'visable',
    },
  ],
  'M4T':[  
    {
      id:0,
      name:"VISIBLE" ,
      key:'visable',
    },
    {
      id:1,
      name:"IR" ,
      key:'ir',
    },
  ]
};

export const  TakeoffType = [     //missionConfig.flyToWaylineMode
  {
    id:0,
    name:"Direct Ascent" ,
    key:'safely',
    img : "/assets/images/flight_settings/takeoff.svg",
  },
  {
    id:1,
    name:"Safe Takeoff" ,
    key:'pointToPoint',
    img : "/assets/images/flight_settings/takeoff.svg",
  },
];

export const  AltitudeMode = [      //Folder.waylineCoordinateSysParam.heightMode
  {
    id:0,
    name:"ASL" ,
    key:'EGM96',
    img : "/assets/images/flight_settings/altitudemode_asl.svg",
  },
  {
    id:1,
    name:"ALT" ,
    key:'relativeToStartPoint',
    img : "/assets/images/flight_settings/altitudemode_alt.svg",
  },
  {
    id:2,
    name:"AGL" ,
    key:'aboveGroundLevel',
    img : "/assets/images/flight_settings/altitudemode_agl.svg",
  },
];

export const  WaypointType = [    // => utiliser dans kml Folder.globalWaypointTurnMode
  {
    id:0,
    name:"Coordinated turn. Skip waypoint" ,
    key:'coordinateTurn',     
    img : "/assets/images/flight_settings/waypointmode_coordinatedturn.svg",
  },
  {
    id:1,
    name:"Straight route. Aircraft stops" ,
    key:'toPointAndStopWithDiscontinuityCurvature',        
    img : "/assets/images/flight_settings/waypointmode_straight.svg",
  },
  {
    id:2,
    name:"Turns before waypoint. Flies through" ,
    key:'toPointAndPassWithContinuityCurvature',     
    img : "/assets/images/flight_settings/waypointmode_advanceturn.svg",
  },
  {
    id:3,
    name:"Curved route. Aircraft stops" ,
    key:'toPointAndStopWithContinuityCurvature',     
    img : "/assets/images/flight_settings/waypointmode_curve1.svg",
  },
  {
    id:4,
    name:"Curved route. Aircraft continues" ,
    key:'toPointAndPassWithContinuityCurvature',       // => utiliser dans kml Folder.globalWaypointTurnMode
    img : "/assets/images/flight_settings/waypointmode_curve2.svg",
  },
];

export const AircraftYaw = [  // => utiliser dans kml Folder.globalWaypointHeadingParam.waypointHeadingMode
  {
    id:0,
    name:"Manual",
    key:'manually',     
  },
  {
    id:1,
    name:"Along Route",
    key:'followWayline',     
  },
  {
    id:2,
    name:"Lock Yaw Axis",
    key:'fixed',     
  }
]

export const GimbalControl = [    // => utiliser dans kml  Folder.gimbalPitchMode
  {
    id:0,
    name:"Manual",
    key:'manual',   
  },
  {
    id:1,
    name:"For Each Waypoint",
    key:'usePointSetting',    
  }
];

export const EndFlight = [    // => utiliser dans kml missionConfig.finishAction
  {
    id:0,
    name:"Return to Home",
    key:'goHome',   
  },
  {
    id:1,
    name:"Return to Start Point and Hover",
    key:'gotoFirstWaypoint',       
  },
  {
    id:2,
    name:"Exit Task",
    key:'noAction',  
  },
  {
    id:3,
    name:"Land",
    key:'autoLand',   
  },
]